import { TenantRoles } from 'modules/application/tenant/TenantService';
import { applicationListStateName } from 'modules/application/list';
import { INITIAL_SETUP_MEMBERS_ADD_GUEST, INITIAL_SETUP_MEMBERS_REMOVE_GUEST, INITIAL_SETUP_MEMBERS_SEND_INVITES, INITIAL_SETUP_MEMBERS_SKIP, INITIAL_SETUP_MEMBERS_SKIP_CONFIRM, } from 'modules/initialSetup/initialSetupSegmentEvents';
import './membersStep.scss';
const EMAIL_REGEX = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
export class MembersStepController {
    static $inject = ['$translate', '$state', 'ContextProcessorService', 'TenantService', 'AccountService2', 'AlertService', 'SegmentService', 'BlipToastService', 'LoadingService', 'BLIP_DOMAIN'];
    constructor($translate, $state, ContextProcessorService, TenantService, AccountService2, AlertService, SegmentService, BlipToastService, LoadingService, BLIP_DOMAIN) {
        'ngInject';
        this.$translate = $translate;
        this.$state = $state;
        this.ContextProcessorService = ContextProcessorService;
        this.TenantService = TenantService;
        this.AccountService2 = AccountService2;
        this.AlertService = AlertService;
        this.SegmentService = SegmentService;
        this.BlipToastService = BlipToastService;
        this.LoadingService = LoadingService;
        this.BLIP_DOMAIN = BLIP_DOMAIN;
        this.invitedAccounts = [];
        this.membersAccounts = [];
        this.onChangeInviteEmail = (event) => {
            this.inviteEmail = event.detail.value;
            this.inviteEmailError = undefined;
        };
        this.onSelectInviteRole = (event) => {
            this.inviteRole = event.detail.value;
        };
        this.canAddInvite = () => {
            return (!!this.inviteEmail &&
                !!this.inviteRole &&
                !this.inviteEmailError);
        };
        this.addInvitedAccount = async () => {
            if (!this.inviteEmail || !this.inviteRole) {
                return;
            }
            if (!this.inviteEmail.match(EMAIL_REGEX)) {
                this.inviteEmailError = await this.$translate('initialSetup.members.email.invalid');
                return;
            }
            if (this.membersAccounts.map(ma => ma.email).includes(this.inviteEmail) ||
                this.invitedAccounts.map(ia => ia.email).includes(this.inviteEmail)) {
                this.inviteEmailError = await this.$translate('initialSetup.members.email.alreadyInUse');
                return;
            }
            const role = this.inviteRole;
            this.invitedAccounts.push({
                email: this.inviteEmail,
                roleId: role,
                roleName: await this.$translate(`initialSetup.members.role.${role}`),
                roleIcon: this.getRoleIcon(role),
            });
            const guestRole = this.inviteRole;
            this.SegmentService.createOrganizationTrack(INITIAL_SETUP_MEMBERS_ADD_GUEST, {
                guestRole,
            });
            this.inviteEmail = undefined;
            this.inviteRole = undefined;
        };
        this.removeInvitedAccount = (index) => {
            const { email, roleId } = this.invitedAccounts[index];
            if (email === this.inviteEmail) {
                this.inviteEmailError = undefined;
            }
            this.invitedAccounts.splice(index, 1);
            this.SegmentService.createOrganizationTrack(INITIAL_SETUP_MEMBERS_REMOVE_GUEST, {
                guestRole: roleId,
            });
        };
        this.skipMembersInvitation = async () => {
            if (this.invitedAccounts.length > 0) {
                this.AlertService.show({
                    variant: 'warning',
                    icon: 'warning',
                    title: await this.$translate('initialSetup.members.skipAlert.title'),
                    body: await this.$translate('initialSetup.members.skipAlert.body'),
                    buttons: {
                        confirm: await this.$translate('initialSetup.members.skipAlert.yes'),
                        cancel: await this.$translate('initialSetup.members.skipAlert.no'),
                    },
                    callback: {
                        confirmButtonAction: this.skipMembersInvitationAlertConfirm,
                        cancelButtonAction: () => undefined,
                    },
                });
                return;
            }
            this.SegmentService.createOrganizationTrack(INITIAL_SETUP_MEMBERS_SKIP, {
                guestCount: this.invitedAccounts.length,
            });
            this.goToNextStep();
        };
        this.skipMembersInvitationAlertConfirm = () => {
            this.SegmentService.createOrganizationTrack(INITIAL_SETUP_MEMBERS_SKIP_CONFIRM, {
                guestCount: this.invitedAccounts.length,
            });
            this.goToNextStep();
        };
        this.inviteMembers = async () => {
            if (this.invitedAccounts.length === 0) {
                return;
            }
            this.LoadingService.startLoading(false);
            try {
                const invitesPerRole = {};
                Object.values(TenantRoles).forEach(role => {
                    const accountsForRole = this.invitedAccounts
                        .filter(ia => ia.roleId === role)
                        .map(ia => ia.email);
                    if (accountsForRole.length > 0) {
                        invitesPerRole[role] = accountsForRole;
                    }
                });
                for (let index = 0; index < Object.keys(invitesPerRole).length; index++) {
                    const roleId = Object.keys(invitesPerRole)[index];
                    const accounts = invitesPerRole[roleId];
                    await this.TenantService.inviteMany(accounts, this.ContextProcessorService.tenant.id, roleId);
                }
            }
            catch {
                this.BlipToastService.show('danger', {
                    msg: await this.$translate('initialSetup.members.errors.cannotAddMember'),
                });
                return;
            }
            finally {
                this.LoadingService.stopLoading();
            }
            this.SegmentService.createOrganizationTrack(INITIAL_SETUP_MEMBERS_SEND_INVITES, {
                guestCount: this.invitedAccounts.length,
            });
            this.goToNextStep();
        };
    }
    async $onInit() {
        this.me = await this.AccountService2.me();
        const { roleId } = await this.TenantService.getTenantUser(this.ContextProcessorService.tenant.id, `${encodeURIComponent(this.me.email)}@${this.BLIP_DOMAIN}`);
        if (roleId !== TenantRoles.Admin) {
            this.goToNextStep();
            return;
        }
        await this.setMemberAccounts();
    }
    async setMemberAccounts() {
        const membersAccounts = [];
        const { items } = await this.TenantService.getTenantUsers(this.ContextProcessorService.tenant.id);
        for (let index = 0; index < items.length; index++) {
            const user = items[index];
            const email = decodeURIComponent(user.userIdentity.split('@')[0]);
            const memberAccount = {
                email,
                me: this.me.email == email,
                roleId: user.roleId,
                roleName: await this.$translate(`initialSetup.members.role.${user.roleId}`),
                roleIcon: this.getRoleIcon(user.roleId),
            };
            try {
                const account = await this.AccountService2.getAccount(user.userIdentity);
                memberAccount.fullName = account.fullName;
                memberAccount.photoUri = account.photoUri;
            }
            catch {
            }
            finally {
                membersAccounts.push(memberAccount);
            }
        }
        // Sort members account list following the priority below:
        // 1. Member set as me
        // 2. Alphabetical order for members with full name
        // 3. alphabetical order for members with only email
        const membersAccountsSorter = () => (a, b) => {
            const me1 = a.me;
            const me2 = b.me;
            const fullName1 = a.fullName;
            const fullName2 = b.fullName;
            const email1 = a.email;
            const email2 = b.email;
            if (me1) {
                return -1;
            }
            if (me2) {
                return 1;
            }
            if (!fullName1 && !fullName2) {
                return email1 < email2 ? -1 : 1;
            }
            if (!fullName1) {
                return 1;
            }
            if (!fullName2) {
                return -1;
            }
            return fullName1 < fullName2 ? -1 : 1;
        };
        this.membersAccounts = membersAccounts.sort(membersAccountsSorter());
    }
    getRoleIcon(roleId) {
        switch (roleId) {
            case TenantRoles.Admin:
                return 'avatar-user';
            case TenantRoles.Member:
                return 'edit';
            case TenantRoles.Guest:
                return 'eye-open';
            default:
                return '';
        }
    }
    goToNextStep() {
        this.$state.go(applicationListStateName);
    }
}
MembersStepController.$inject = ['$translate', '$state', 'ContextProcessorService', 'TenantService', 'AccountService2', 'AlertService', 'SegmentService', 'BlipToastService', 'LoadingService', 'BLIP_DOMAIN'];
